import { endPoint } from "constants/server/api";
import { createFetchMaster } from "../../utils/fetchFactory";
import { createSlicePrototype } from "../../utils/sliceFactory";
var getAllMstNewItemInvoiceColSlice = createSlicePrototype({
    name: "getAllMstNewItemInvoiceCol"
});
export var getAllMstNewItemInvoiceCol = createFetchMaster({
    actions: getAllMstNewItemInvoiceColSlice.actions,
    config: {
        method: "get",
        url: endPoint.MST_NEW_ITEM_INVOICE_COL
    }
});
var _getAllMstNewItemInvoiceColSlice_actions = getAllMstNewItemInvoiceColSlice.actions;
export var fetchData = _getAllMstNewItemInvoiceColSlice_actions.fetchData, fetchDataSuccess = _getAllMstNewItemInvoiceColSlice_actions.fetchDataSuccess, fetchDataFailure = _getAllMstNewItemInvoiceColSlice_actions.fetchDataFailure, resetState = _getAllMstNewItemInvoiceColSlice_actions.resetState;
export default getAllMstNewItemInvoiceColSlice.reducer;
